<template>
  <div class="log-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="gotohome">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <span class="nav-title">{{ udname }} - 运行日志</span>
      </template>
    </van-nav-bar>

    <van-tabs v-model="activeTab" color="#2dd4bf" title-active-color="#0d9488" class="crystal-tabs">
      <van-tab title="补水记录">
        <div class="tab-content">
          <div v-if="replenishLogs.length === 0" class="empty-state">
            <span class="iconfont icon-bushuitubiao empty-icon"></span>
            <div class="empty-text">暂无补水记录</div>
          </div>
          <div v-for="(log, index) in replenishLogs" :key="index" class="log-card">
            <div class="log-body">
              <div class="log-row">
                <span class="log-label">启动原因</span>
                <span class="log-value">{{ formatReplenishStart(log.st) }}</span>
              </div>
              <div class="log-row">
                <span class="log-label">补水用时</span>
                <span class="log-value">{{ formatSec(log.tm) }}</span>
              </div>
              <div class="log-row">
                <span class="log-label">结束原因</span>
                <span class="log-value" :class="log.et === 0 ? '' : 'value-warn'">{{ formatReplenishEnd(log.et) }}</span>
              </div>
              <div class="log-row log-row--last">
                <span class="log-label">时间</span>
                <span class="log-value">{{ formatLogTime(log.create_time) }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="换水记录">
        <div class="tab-content">
          <div v-if="wcLogs.length === 0" class="empty-state">
            <span class="iconfont icon-huanshui empty-icon"></span>
            <div class="empty-text">暂无换水记录</div>
          </div>
          <div v-for="(log, index) in wcLogs" :key="index" class="log-card">
            <div class="log-body">
              <div class="log-row">
                <span class="log-label">启动原因</span>
                <span class="log-value">{{ formatWcStart(log.st) }}</span>
              </div>
              <div class="log-row">
                <span class="log-label">总用时</span>
                <span class="log-value">{{ formatSec(log.tm) }}</span>
              </div>
              <div class="log-row">
                <span class="log-label">补淡水</span>
                <span class="log-value">{{ log.fwt != null ? formatSec(log.fwt) : '--' }}</span>
              </div>
              <div class="log-row">
                <span class="log-label">补海水</span>
                <span class="log-value">{{ log.swt != null ? formatSec(log.swt) : '--' }}</span>
              </div>
              <div class="log-row">
                <span class="log-label">结束原因</span>
                <span class="log-value" :class="log.et === 0 ? '' : 'value-warn'">{{ formatWcEnd(log.et, log.step) }}</span>
              </div>
              <div class="log-row log-row--last">
                <span class="log-label">时间</span>
                <span class="log-value">{{ formatLogTime(log.create_time) }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "KD2Log",
  data() {
    return {
      activeTab: 0,
      did: this.$route.query.did,
      udname: this.$route.query.udname || "KD-2设备",
      replenishLogs: [],
      wcLogs: [],
    };
  },
  mounted() {
    this.gethistory();
  },
  methods: {
    gethistory() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/history", qs.stringify({
          did: this.did,
          dtype: "KD-2",
          history: "log",
          tnum: 30,
          tunit: "day",
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            var logBuf = response.data.data.log_buf;
            this.replenishLogs = this.parseLogs(logBuf.replenish);
            this.wcLogs = this.parseLogs(logBuf.water_change);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    parseLogs(rawLogs) {
      if (!rawLogs || !rawLogs.length) return [];
      return rawLogs.map(function (entry) {
        var parsed = JSON.parse(entry[0]);
        parsed.create_time = entry[1];
        return parsed;
      });
    },
    formatLogTime(ts) {
      return ts || "";
    },
    formatSec(sec) {
      if (sec == null || sec <= 0) return "0秒";
      if (sec < 60) return `${sec}秒`;
      if (sec < 3600) return `${Math.floor(sec / 60)}分${sec % 60}秒`;
      var h = Math.floor(sec / 3600);
      var m = Math.floor((sec % 3600) / 60);
      return `${h}时${m}分`;
    },
    formatReplenishStart(st) {
      var map = { 1: "自动启动", 2: "手动启动" };
      return map[st] || `未知(${st})`;
    },
    formatReplenishEnd(et) {
      var map = { 0: "补水完成", "-1": "补水超时", "-2": "干烧停止", "-3": "手动停止", "-6": "手动停止" };
      return map[String(et)] || `未知(${et})`;
    },
    formatWcStart(st) {
      var map = { 1: "自动启动", 2: "手动启动" };
      return map[st] || `未知(${st})`;
    },
    formatWcEnd(et, step) {
      if (et === 0) return "换水完成";
      if (et === -1) return `换水超时(第${step}步)`;
      if (et === -6) return `手动停止(第${step}步)`;
      if (et === -7) return "污水桶满";
      return `未知(${et})`;
    },
    formatWcStep(step) {
      var map = { 0: "准备中", 1: "补淡水", 2: "排水", 3: "补海水" };
      return map[step] || `步骤${step}`;
    },
    gotohome() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  max-width: 70vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.crystal-tabs .van-tabs__wrap {
  background: #ffffff;
}

.crystal-tabs .van-tab {
  font-weight: 500;
}
</style>

<style scoped>
.log-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f8fafc;
}

.tab-content {
  padding: 12px;
  height: calc(100vh - 92px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #94a3b8;
}

.empty-icon {
  font-size: 48px;
  opacity: 0.4;
  margin-bottom: 12px;
}

.empty-text {
  font-size: 14px;
  font-weight: 500;
}

.log-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  margin-bottom: 10px;
}

.log-body {
  padding: 12px 14px 10px;
}

.log-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.log-row--last {
  padding-bottom: 0;
}

.log-label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
}

.log-value {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}

.value-warn {
  color: #ef4444;
}
</style>
